import request from '@/utils/request'
// 查询安全库存类别定义头列表
export function apiSopRatioHeadList (query) {
    return request({
      url: '/scp/sopRatioHead/list',
      method: 'get',
      params: query
    })
  }
  // 删除查询安全库存类别定义头列表
export function apiDeleteSopRatioHeadList (query) {
  return request({
    url: '/scp/sopRatioHead',
    method: 'delete',
    params: query
  })
}
  // 查询安全库存类别定义头列表
export function apiNewSopRatioHeadList (query) {
    return request({
      url: '/scp/sopRatioHead',
      method: 'post',
      data: query
    })
  }
    // 更新列
export function apiUpdateSopRatioLines (query) {
  return request({
    url: '/scp/sopRatioLines',
    method: 'put',
    data: query
  })
}
    // 更新列
    export function apiDelSopRatioLines (query) {
      return request({
        url: '/scp/sopRatioLines',
        method: 'delete',
        data: query
      })
    }
  // 查询安全库存类别定义列列表
export function apiSopRatioLinesList (query) {
  return request({
    url: '/scp/sopRatioLines/list',
    method: 'get',
    params: query
  })
}
